import { render, staticRenderFns } from "./reviewReject.vue?vue&type=template&id=ce110f76"
import script from "./reviewReject.vue?vue&type=script&lang=js"
export * from "./reviewReject.vue?vue&type=script&lang=js"
import style0 from "./reviewReject.vue?vue&type=style&index=0&id=ce110f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports